<template>
  <div id="app">
    <div>
      <md-app id="mdapp" v-if="loggedIn">

        <md-app-toolbar class="md-primary">
          <md-button class="md-icon-button" @click="toggleMenu" v-if="!menuVisible">
            <md-icon>menu</md-icon>
          </md-button>
          <span class="md-title">{{ $portalName }} - {{ $route.name }}</span>

          <md-menu md-direction="bottom-start" style="position:absolute;right:0px;margin:10px;">
            <md-button class="md-icon-button md-raised" md-menu-trigger>
              <md-icon style="color:black;">perm_identity</md-icon>
            </md-button>

            <md-menu-content>
              <md-menu-item><span>Ingelogd als: <b>{{ loginName }}</b></span></md-menu-item>
              <md-menu-item @click="logout" class="md-accent"><b>Uitloggen</b></md-menu-item>
            </md-menu-content>
          </md-menu>
        </md-app-toolbar>

        <md-app-drawer :md-active.sync="menuVisible" md-persistent="full">
          <md-toolbar class="md-transparent" md-elevation="0">
            <img :src="logoSrc" style="max-height:40pt;margin:10pt 0pt;" />
            <div class="md-toolbar-section-end">
              <md-button class="md-icon-button md-dense md-raised md-accent" @click="toggleMenu">
                <md-icon>keyboard_arrow_left</md-icon>
              </md-button>
            </div>
          </md-toolbar>

          <md-list>
            <div v-for="group in menuItems">
              <div v-if="group.name" style="padding-top: 12pt;">
                <md-subheader class="menuSubheader md-primary">{{ group.name }}</md-subheader>
              </div>

              <md-list-item v-for="page in group.pages" :key="page.name" @click="onMenuItemClick(page)">
                <md-icon v-if="page.icon" :class="$route.name.toLowerCase() == page.name.toLowerCase() ? 'md-primary' : 'null'">{{ page.icon }}</md-icon>
                <span class="md-list-item-text">{{ page.name }}</span>
              </md-list-item>
            </div>
          </md-list>
        </md-app-drawer>

        <md-app-content>
          <transition name="fade">
            <router-view />
          </transition>
        </md-app-content>

      </md-app>

      <div id="login" v-else style="position:absolute;width:100%;height:100%;">
        <login-block @loggedIn="onLoggedIn" />
      </div>
    </div>

    <md-dialog :md-active.sync="alert.show">
      <md-dialog-title>{{ alert.title }}</md-dialog-title>

      <md-dialog-content>
        <p class="md-body-1 accept-linebreak">{{ alert.msg }}</p>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary md-raised" @click="alert.show = false">Ok</md-button>
      </md-dialog-actions>
    </md-dialog>

  </div>
</template>

<script>
  import { Events } from '@wsb/wsb-jsbase';
  import login from '@/components/Login';

  var menu = [
    {
      pages: [
        { name: "Start", icon: "home", route: '/' }
      ]
    },
    {
      name: "Paginas",
      pages: [
        { name: "Lopende orders", icon: "shopping_cart", route: '/LopendeOrders' },
        { name: "Pakbonnen", icon: "send", route: '/Pakbonnen' },
        { name: "Facturen", icon: "note", route: '/Facturen' },
        { name: "Open posten", icon: "swap_vert", route: '/OpenPosten' },
/////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////
//////////
        { name: "Licentie overzicht", icon: "person", route: '/Licenties' }
      ]
    },
    {
      name: "Rapporten",
      pages: [
        { name: "Minas rapportage", route: '/Minas' },
        { name: "Afname per productgroep", route: '/Afname' },
///////////////////////
////////////////////////////////////////////////////////////////////
//////////
      ]
    }
  ];

/////////////////////////
//////////////////////////////////////////////////////
//////////////////////////
//////////////////////////////////////////////////////
//////////////////////////
  var logoSrc = require('@/assets/alli/FullLogo.png');
/////////////////////////
//////////////////////////////////////////////////////
////////////

  const _app = {
    name: 'App',
    data: () => ({
      loggedIn: false,
      loginName: null,
      alert: {
        show: false,
        title: 'Er is iets mis gegaan...',
        msg: ''
      },
      menuVisible: true,
      menuItems: menu,
      logoSrc: logoSrc
    }),
    methods: {
      toggleMenu() {
        this.menuVisible = !this.menuVisible;
      },
      onMenuItemClick(page) {
        this.$router.push(page.route);
      },
      onLoggedIn() {
        this.loggedIn = true;
        this.setName();
      },
      setName() {
        if (global.Auth.IsLoggedIn()) {
          global.Auth.GetToken()
            .then(tok => {
              this.loginName = tok.sub;
            });
        }
      },
      logout() {
        global.Auth.Logout();
        this.loggedIn = false;
      }
    },
    components: {
      'login-block': login
    },
    created() {
      this.loggedIn = global.Auth.IsLoggedIn();
      this.setName();

      Events.OnDeauthorized(() => {
        console.log('handling deauth');
        this.loggedIn = false;
      });
      Events.OnExceptionOccurred(e => {
        console.log(`App.OnExceptionOccurred: '${e.detail}'`);
        if (e.detail) {
          this.alert.msg = e.detail;
          this.alert.show = true;
        }
      });
    }
  };

  export default _app;
</script>

<style>
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  #mdapp {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    position: absolute;
    width: 100%;
    min-height: 100%;
  }
  .menuSubheader {
    font-size: 12pt;
  }

  .fade-enter-active {
    transition: opacity .5s;
  }
  .fade-enter {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue